import Card from '@carvana/ds-card';
import BudgetFriendly from '@carvana/ds-icons/BudgetFriendlySpot';
import CalcPercentage from '@carvana/ds-icons/CalcPercentageSpot';
import { Check } from 'lucide-react';
import Section from '~/components/flp/Section';
import { ANALYTICS_EVENTS } from '~/constants/flp/analyticsEvents';
import {
  AllCreditTypesSection,
  Container,
  Content,
  Description,
  Header,
  Heading,
  PropositionCopy,
  PropositionHeading
} from './AllCreditTypes.styles';
import AllCreditTypesCta from './AllCreditTypesCta';

const propositions = [
  {
    icon: <Check />,
    title: '99% approval rate*',
    description:
      'All credit situations welcome. Get pre-qualified for an auto loan, even with bad credit, no credit or past bankruptcy.'
  },
  {
    icon: <BudgetFriendly />,
    title: 'Affordable vehicles',
    description:
      'Explore budget-friendly cars. Choose from vehicles with manageable monthly payments.'
  },
  {
    icon: <CalcPercentage />,
    title: 'Low down payments',
    description: 'Get on the road today without draining your savings.'
  }
];

export default function AllCreditTypes() {
  return (
    <Section
      as={AllCreditTypesSection}
      eventName={ANALYTICS_EVENTS.MARKETING.SECTION_VIEWED_ALLCREDITTYPES}
    >
      <Container>
        <Header>
          <Heading>We welcome all credit types</Heading>
          <Description>
            From perfect credit to rebuilding credit, everyone deserves access
            to affordable vehicle financing.
          </Description>
        </Header>
        <Content>
          {propositions.map(({ icon, title, description }) => (
            <Card
              key={title}
              classes={{ content: 'flex flex-col gap-lg p-2xl' }}
            >
              {icon}
              <PropositionHeading>{title}</PropositionHeading>
              <PropositionCopy>{description}</PropositionCopy>
            </Card>
          ))}
        </Content>
        <AllCreditTypesCta />
      </Container>
    </Section>
  );
}
